export class ReservationDto {
    id: number;
    dateFrom: Date;
    dateUntil: Date;
    carparkId: number;
    licensePlate: string;
    firstName: string;
    surname: string;
    email: string;
    tenantId: number;
    paymentMode: string;
    qrCode: string;
    sendEmail: boolean;
    status: string;

    toString(): string {
        return "id: " + this.id + ", dateFrom: " + this.dateFrom + ", dateUntil: " +
            this.dateUntil + ", carparkId: " + this.carparkId + ", licensePlate: " +
            this.licensePlate + ", firstName: " + this.firstName + ", surname: " +
            this.surname + ", email: " + this.email + ", tenantId: " + this.tenantId +
            ", paymentMode: " + this.paymentMode + ", qrCode: " + this.qrCode + ", sendEmail: " + this.sendEmail;
    }
}
